// extracted by mini-css-extract-plugin
export default {"normal":"ButtonAlert_normal__J7RRx","disabled":"ButtonAlert_disabled__17TH9","button":"ButtonAlert_button__DSckf"};